<template>
      <v-text-field
        v-model="email"
        label="Email adres"
        :error="error"
        :error-messages="message"
        v-on:blur='handleBlur'
      >
      </v-text-field>
</template>

<script>
import * as EmailValidator from "email-validator";
import { mapState } from "vuex";

export default {
  props: {
    target: {
      type: String,
      default: undefined,
      required: true
    }
  },
  data() {
    return {
      email: "",
      valid: false,
      error: false,
      message: ""
    };
  },
  computed: {
    ...mapState(["object"])
  },
  methods: {
    handleBlur() {
      try {
        this.valid = EmailValidator.validate(this.email);
        if (!this.valid) {
          this.error = true;
          this.message = "Email is niet geldig";
        } else {
          this.error = false;
          this.message = "";
          if (this.$store.state.form[this.target] !== this.email) {
            this.$store.state.form[this.target] = this.email;
            this.$store.state.app.form.hasChange = true;
          }
        }
      } catch (error) {
        this.error = true;
        this.message = "Email is niet geldig";
      }
    }
  },
  computed: {
    details() {
      return this.$store.state.form[this.target];
    }
  },
  created() {
    if (this.$store.state.form[this.target] !== undefined) {
      this.email = this.$store.state.form[this.target];
    }
  },
  watch: {
    details() {
      this.email = this.$store.state.form[this.target];
      this.error = false;
      this.message = "";
    }
  }
};
</script>
